import { createFileRoute } from '@tanstack/react-router'
import { SupplierPaymentsListPage } from '../../../features/purchasing/payments-list-page'
import { paymentSearchSchema } from '../../../features/purchasing/search'

export const Route = createFileRoute('/_app/supplier-payments/')({
  validateSearch: paymentSearchSchema,
  component: SupplierPaymentsListPage,
})
